import { Box, Divider } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import AdditionalTaxes from './summaryAdditionalTaxes/AdditionalTaxes';
import summaryPricesStyles from './summaryPricesStyles';
import usePlatformConfig from '../../../../../../../common/react/usePlatformConfig';
import IPrice from '../../../../../../../gqlCommon/model/prices/IPrice';
import {
  GetCustomizeCar_customizeCar_additionalGovernmentTaxes,
  GetCustomizeCar_customizeCar_prices_carPrice_offers_discounts as IDiscount,
} from '../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import SummaryDiscountsList from './summaryDiscounts/SummaryDiscountsList';
import SummarySelection from './summarySelections/SummarySelection';
import SummaryOffers from './summaryOffers/SummaryOffers';
import SummaryTaxes from './summaryTaxes/SummaryTaxes';
import SummaryTotalPrice from './summaryTotalPrice/SummaryTotalPrice';
import SummaryOriginalPrice from './summaryOriginalPrice/SummaryOriginalPrice';
import TrimLevelName from '../../../../../../../common/components/trimLevelsName/trimLevelName/TrimLevelName';
import Translation from '../../../../../../../gqlCommon/components/translation/Translation';
import ITaxes from '../../../../../../../gqlCommon/model/ITaxes';
import {
  GetCustomizeCar_customizeCar_prices_carPrice_originalPrice,
  GetCustomizeCar_customizeCar_prices_totalPrice,
} from '../../../../../../graphql/queries/__generated__/GetCustomizeCar';

export interface ISummaryPricesProps {
  title: string;
  loading?: boolean;
  currency: string;
  originalPrice: GetCustomizeCar_customizeCar_prices_carPrice_originalPrice[];
  totalPrices: GetCustomizeCar_customizeCar_prices_totalPrice[];
  registrationTax?: ITaxes;
  totalFeatures: IPrice[];
  totalOfferFeatures: IPrice[];
  discounts: IDiscount[];
  basketDiscounts: IDiscount[] | null;
  taxLabel?: string;
  additionalGovernmentTaxes: GetCustomizeCar_customizeCar_additionalGovernmentTaxes[];
  oneForOneReplacement?: boolean;
}

const SummaryPrices: FunctionComponent<ISummaryPricesProps> = ({
  title,
  loading,
  currency,
  originalPrice,
  totalPrices,
  totalFeatures,
  totalOfferFeatures,
  discounts,
  basketDiscounts,
  taxLabel,
  additionalGovernmentTaxes,
  oneForOneReplacement,
}) => {
  const {
    platformConfig: { isComplexModel, configurator, hideSelectionsSection },
  } = usePlatformConfig();
  const summaryShowTaxes = configurator.summaryShowTaxes;
  const styles = summaryPricesStyles();

  const trimLevelName = (
    <TrimLevelName
      name={title}
      type="span"
      section="summary"
      dataTest="trim_level_name:trim"
      classes={{ variantNameText: styles.variantNameText }}
    />
  );

  return (
    <Box className={styles.pricesContainer}>
      <SummaryOriginalPrice
        label={trimLevelName}
        prices={originalPrice}
        currency={currency}
        labelClassNames={styles.complexVehicleTitle}
        loading={loading}
        taxLabel={taxLabel}
        summaryShowTaxes={summaryShowTaxes}
      />
      {discounts && <SummaryDiscountsList loading={loading} currency={currency} discounts={discounts} />}

      {!hideSelectionsSection && (
        <SummarySelection
          loading={loading}
          currency={currency}
          prices={totalFeatures}
          boldLabel={false}
          summaryLabel={<Translation id={'trans__configurator__customise_page_summary_section__selections_label'} />}
          taxLabel={taxLabel}
        />
      )}
      {!!totalOfferFeatures?.length && (
        <SummaryOffers
          loading={loading}
          currency={currency}
          prices={totalOfferFeatures}
          summaryLabel={<Translation id={'trans__configurator__customise_page_summary_section__offers'} />}
        />
      )}
      {summaryShowTaxes && <SummaryTaxes loading={loading} prices={totalPrices} currency={currency} />}
      {basketDiscounts && <SummaryDiscountsList loading={loading} currency={currency} discounts={basketDiscounts} />}
      <Divider />
      <SummaryTotalPrice
        prices={totalPrices}
        currency={currency}
        isComplexModel={isComplexModel}
        loading={loading}
        taxLabel={taxLabel}
        oneForOneReplacement={oneForOneReplacement}
      />
      <AdditionalTaxes loading={loading} additionalGovernmentTaxes={additionalGovernmentTaxes} />
    </Box>
  );
};

export default SummaryPrices;
